<template>
  <div class="content-block dx-card">
    <h2>Property Lists</h2> <!-- ❯ = unicode U+276F  -->
  </div>
  <div v-if="loading" class="loading-overlay">
    LOADING...
    <span class="loader"></span>
  </div>
  <div v-else>

  <div class="content-block dx-card" id="dataDiv">
    <DxDataGrid class="dx-card wide-card" :data-source="propertyLists" :hover-state-enabled="true"
      :selection="{ mode: 'single' }" :show-borders="true" :columns-auto-width="true" :column-min-width="50"
      :allow-column-resizing="true" :column-resizing-mode="columnResize" :allow-column-reordering="true"
      :filter-builder="filterBuilder" :filter-value="filterValue" :style="{ 'max-height': datagridHeight }"
      no-data-text="No data." @selection-changed="onSelectionChanged" @initialized="saveGridInstance"
      @exporting="onExporting">
      <DxLoadPanel :enabled="true" />
      <DxColumnChooser :enabled="true" mode="select" />
      <DxFilterRow :visible="true" />
      <DxHeaderFilter :visible="true" />
      <DxScrolling mode="standard" />
      <DxExport :enabled="true" />
      <DxColumnFixing :enabled="true" />
      <DxPager :show-info="true" :show-page-size-selector="true" :allowed-page-sizes="[20, 50, 100]"
        :show-navigation-buttons="true" />

      <DxToolbar>
        <DxItem location="before" template="addRecordTemplate" />
        <DxItem location="after" template="refreshRecordTemplate" />
        <DxItem location="after" template="removeFilterRecordTemplate" />
        <DxItem location="after" name="exportButton" />
        <DxItem location="after" name="columnChooserButton" />
      </DxToolbar>

      <template #addRecordTemplate>
        <DxButton icon="add" @click="newRec" />
      </template>
      <template #refreshRecordTemplate>
        <DxButton icon="refresh" @click="refreshData" />
      </template>
      <template #removeFilterRecordTemplate>
        <DxButton icon="filter" @click="removeFilter" />
      </template>

      <DxColumn data-field="propListId" caption="ID" />
      <DxColumn data-field="propertyId" caption="Container Type">
        <DxLookup :data-source="properties" value-expr="propertyId" display-expr="containerTypeName" />
      </DxColumn>
      <DxColumn data-field="propertyId" caption="Property">
        <DxLookup :data-source="properties" value-expr="propertyId" display-expr="propertyName" />
      </DxColumn>

      <DxColumn data-field="listValue" caption="Value" />
      <DxColumn data-field="propertyExternal" caption="External ID" />

    </DxDataGrid>
  </div>

  <DxLoadPanel v-model:visible="loadingVisible" :message="Loading" :show-indicator="true" :show-pane="true"
    :shading="true" :hide-on-outside-click="false" :on-shown="onLoadPanelShown" :on-hidden="onLoadPanelHidden"
    shading-color="rgba(0,0,0,0.4)" />
  <!-- :position="{ of: '#dataDiv' }" -->
  <!-- container="#dataDiv" -->
  </div>
</template>

<script>

// import {DxToolbar} from 'devextreme-vue/toolbar';
// import {DxExport} from "devextreme-vue/chart";
import {
  DxDataGrid,
  DxColumn,
  DxHeaderFilter,
  DxFilterRow,
  DxScrolling,
  DxColumnChooser,
  DxColumnFixing,
  DxPager,
  DxItem,
  DxLookup,
  DxToolbar,
  DxExport,
} from "devextreme-vue/data-grid";
import { DxButton } from 'devextreme-vue/button';
import { DxLoadPanel } from 'devextreme-vue/load-panel';

export default {
  components: {
    DxDataGrid,
    DxColumn,
    DxHeaderFilter,
    DxFilterRow,
    DxScrolling,
    DxColumnChooser,
    DxLookup,
    DxLoadPanel,
    DxButton,
    DxToolbar,
    DxItem,
    DxExport,
    DxColumnFixing,
    DxPager,
  },
  created() {
    this.loadPageData();
  },
  mounted() {
    window.addEventListener('resize', this.setDimensions);
    this.setDimensions();
  },
  unmounted() {
    window.removeEventListener('resize', this.setDimensions);
  },
  data() {
    return {
      loading: true,
      columnResize: 'widget',
      dataGridInstance: null,
      loadingVisible: false,
      isLoadPanelVisible: false,
      datagridHeight: '40vh',
    };
  },
  computed: {
    properties() {
      var propsWithType = this.$store.getters["properties/getProperties"]
      if (propsWithType) {
        propsWithType = propsWithType.map(x => {
          x['containerTypeName'] = this.containerTypes.filter(y => y.containerTypeId == x.containerTypeId)[0].containerTypeName
          return x
        })
        return propsWithType
      }
      return null
    },
    productProperties() {
      var newProp = this.$store.getters["properties/getProperties"]
      if (this.$store.getters["properties/getProperties"]) {
        var props = JSON.parse(JSON.stringify(this.$store.getters["properties/getProperties"].filter(x => x.propertyName.includes('Product'))))
        console.log("PROPS", props)
      }
      newProp = newProp.map(x => {
        x['containerTypeName'] = this.containerTypes.filter(y => y.containerTypeId == x.containerTypeId)[0].containerTypeName
        return x
      })
      // return this.$store.getters["properties/getProperties"];
      return newProp;
    },
    propertyLists() {
      return this.$store.getters["properties/getPropertyLists"];
    },
    containerTypes() {
      return this.$store.getters["containerTypes/getContainerTypes"];
    },
  },
  methods: {
    getContainerType(property) {
      // var type = this.properties.filter(x=>x.propertyId==propertyId).containerTypeId
      // console.log("GCT", property, this.containerTypes.filter(x=>x.containerTypeId==property.containerTypeId).containerTypeName)
      console.log(this.containerTypes[0].containerTypeName)

      property['containerType'] = this.containerTypes.filter(x => x.containerTypeId == property.containerTypeId)[0].containerTypeName
      return property
    },
    // getContainerType(propertyId){
    //   console.log(propertyId)
    //   if (this.properties){
    //     var type =this.properties.filter(x=>x.propertyId==propertyId).containerTypeId
    //     return this.containerTypes.filter(x=>x.containerTypeId==type).containerTypeName
    //   }
    //   return null;
    // },
    onLoadPanelShown() {
      setTimeout(() => { this.loadingVisible = false; }, 10000);
    },
    onLoadPanelHidden() {
      // this.employeeInfo = employee;
    },
    saveGridInstance: function (e) {
      this.dataGridInstance = e.component;
    },
    setDimensions() {
      const h = document.documentElement.clientHeight;
      this.datagridHeight = (h - 250) + 'px';
    },
    newRec() {
      this.$router.push({ name: 'property-list-details', params: { id: 0 } });
    },
    removeFilter() {
      this.dataGridInstance.clearFilter();
      this.dataGridInstance.clearSorting();
    },
    refreshData() {
      this.loadPageData();
    },
    onSelectionChanged({ selectedRowsData }) {
      this.$router.push({ name: 'property-list-details', params: { id: selectedRowsData[0].propListId } });
    },
    async loadPageData(refresh = false) {
      this.loading = true;
      this.loadingVisible = true;
      try {
        await this.$store.dispatch("containerTypes/loadContainerTypes", { forceRefresh: refresh });
        await this.$store.dispatch("properties/loadProperties", { forceRefresh: refresh });
        await this.$store.dispatch("properties/loadPropertyLists", { forceRefresh: refresh });
      } catch (error) {
        this.error = error.message || "Unexpected Error.";
      } finally {
        this.loading = false;
        this.loadingVisible = false;
      }
    },
    onExporting(e) {
      e.fileName = `PropertyListsDataExport_${new Date().toISOString().slice(0, 10)}`;
    },
  }
};
</script>

<style scoped>
h2 {
  margin-left: 1em;
}
</style>
